import { z } from 'zod';
import type { TFunction } from 'i18next';

const createPasswordRecoveryFormSchema = (t: TFunction) => {
  const required = t('authPages.validation.requiredField');
  const emailSchema = z
    .string()
    .nonempty({ message: required })
    .email({
      message: t('authPages.validation.emailInvalid'),
    });
  return z.object({ email: emailSchema });
};

export { createPasswordRecoveryFormSchema };
